export default function () {
  return (
<svg className="Smiley__icon" xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none">
  <path d="M15.03 30.99a15.03 15.03 0 1 0 0-30.06 15.03 15.03 0 0 0 0 30.06Z"/>
  <path stroke="#5B82FF" strokeMiterlimit="10" strokeWidth="2" d="M24.54 15.96a9.51 9.51 0 0 1-19.02 0"/>
  <path fill="#5B82FF" d="m9.38 14.68.18-1.95-1.62 1.13-.89-1.55 1.77-.82-1.77-.82.89-1.55 1.62 1.13-.18-1.95h1.77l-.18 1.95 1.62-1.13.89 1.55-1.77.82 1.77.82-.89 1.55-1.62-1.13.18 1.95H9.38Zm10.65 0 .18-1.95-1.62 1.13-.89-1.55 1.77-.82-1.77-.82.89-1.55 1.62 1.13-.18-1.95h1.77l-.18 1.95 1.62-1.13.89 1.55-1.77.82 1.77.82-.89 1.55-1.62-1.13.18 1.95h-1.77Z"/>
</svg>
  );
}
